import Action from "../base/action";
import LoadTimeline from "../base/load-timeline";

class SelectOneOption extends Action {
    heading;
    until;
    cancelAction;
    pickAction;
    _pickerOptions;

    constructor(props) {
        super(props);
        this.heading = props.heading;
        this.until = props.until;
        this.cancelAction = props.cancelAction && new LoadTimeline(props.cancelAction);
        this.pickAction = props.timelineMap.map(option => new LoadTimeline(option));
        this._pickerOptions = props.timelineMap.map((option, index) => ({
            text: option.text,
            value: index + 1
        }));
    }

    async execute(eventLoop) {
        let self = this;
        this._stopper = activatePicker();
        setTimeout(() => this._stopper, this.until - this.startTime);

        function activatePicker() {
            const picker = PickerManager.addNewPicker(cameraTracker, self.heading, self._pickerOptions, handleItemSelect);
            return () => PickerManager.removePicker(picker);
        }

        async function handleItemSelect(pickId) {
            if (!pickId && self.cancelAction) {
                return await self.cancelAction.execute(eventLoop);
            }

            const nextAction = getNextTimeline(pickId);
            if (nextAction) {
                self._stopper();
                await nextAction.execute(eventLoop);
            }
        }

        function getNextTimeline(pickId) {
            return self.pickAction[pickId - 1];
        }
    }

    async stop() {
        this._stopper();
    }
}

export default SelectOneOption;
